module.exports = __webpack_public_path__ + "img/105.2.4efd4e4b.png";